import { Star } from 'lucide-react';
import { REVIEWS } from '../data/content';
import SEO from '../components/SEO';
import { Reveal } from '../hooks/useReveal';

export default function Reviews() {
  return (
    <>
      <SEO title="Reviews — Customer Feedback for Laraé Logistics London"
        description="Real reviews from real customers across London and the UK. See what families and businesses say about Laraé Logistics." />
      <section className="bg-forest text-white py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
          <Reveal>
            <p className="font-manrope text-sm text-oat uppercase tracking-widest mb-3">Reviews</p>
            <h1 className="font-outfit text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight">What our customers say.</h1>
            <p className="font-manrope text-base md:text-lg text-white/80 mt-5 max-w-2xl">Real words from real customers across London and throughout the UK — covering local moves, long-distance relocations and office moves.</p>
          </Reveal>
        </div>
      </section>
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <Reveal key={i} delay={i * 60}>
              <div className="bg-white border border-sand rounded-2xl p-7 h-full hover:border-forest hover:-translate-y-0.5 transition-all">
                <div className="flex mb-3">{[1,2,3,4,5].map(s=><Star key={s} size={14} className="fill-oat text-oat" />)}</div>
                {r.service && <div className="inline-block text-[10px] font-manrope uppercase tracking-widest text-forest bg-sand border border-oat/30 rounded-full px-2.5 py-1 mb-3">{r.service}</div>}
                <p className="font-manrope text-sm text-ink/80 leading-relaxed">"{r.text}"</p>
                <div className="mt-5 font-manrope text-sm font-medium text-ink">{r.name} <span className="text-ink/50 font-normal">· {r.area}</span></div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
